const Title = ({ title, stage, align = "center" }) => {
  return (
    <h2 className="text-center text-3xl font-bold leading-none text-black dark:text-white">
      {title}
    </h2>
  );
};

export default Title;
